import { AppstoreAddOutlined } from "@ant-design/icons";
import { Button, Col, Form, Modal, Row, Switch, Input } from "antd";
import { ButtonActiveModal } from "../../../components/Buttons/ButtonActiveModal";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import { TableGeneral } from "../../../components/table/TableGeneral";
import { usePageAreasData } from "../../../hooks/controlPanel";

const { Search } = Input;

export const PageAreas = () => {
    const {
        changeColor,
        color,
        searchValue,
        activeModal,
        typeModal,
        loadingButton,
        form,
        isLoading,
        handleOpenModalCreate,
        closeModal,
        onFinish,
        tableFilterDataAreas,
        handleChange,
        columns,
        tableProps,
        pagination,
        tablePagination,
    } = usePageAreasData();

    return (
        <div className="lg:p-12 p-4 w-full h-full flex flex-col gap-6">
            <CardDetailProject
                title="Áreas"
                headerChildren={
                    <>
                        <ButtonActiveModal
                            icon={<AppstoreAddOutlined />}
                            action={handleOpenModalCreate}
                            className="bg-primaryTwo hover:bg-primaryTwoHover px-6 py-2 flex justify-center items-center lg:order-3 lg:mx-auto"
                            size={{ w: 120, h: 32 }}
                            title="Crear área"
                        />
                        <div className="py-1 px-4 h-8 w-full md:w-48 flex justify-between items-center font-bold rounded-md bg-lowGray lg:mx-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                    d="M1.5 4.75C1.5 4.336 1.836 4 2.25 4H6.25C6.664 4 7 4.336 7 4.75V7.25C7 7.664 6.664 8 6.25 8H2.25C2.05109 8 1.86032 7.92098 1.71967 7.78033C1.57902 7.63968 1.5 7.44891 1.5 7.25V4.75ZM9.5 5.75C9.5 5.336 9.836 5 10.25 5H13.75C14.164 5 14.5 5.336 14.5 5.75V11.25C14.5 11.664 14.164 12 13.75 12H10.25C10.0511 12 9.86032 11.921 9.71967 11.7803C9.57902 11.6397 9.5 11.4489 9.5 11.25V5.75ZM2.5 10.75C2.5 10.336 2.836 10 3.25 10H6.75C7.164 10 7.5 10.336 7.5 10.75V12.25C7.5 12.664 7.164 13 6.75 13H3.25C3.05109 13 2.86032 12.921 2.71967 12.7803C2.57902 12.6397 2.5 12.4489 2.5 12.25V10.75Z"
                                    stroke="#282828"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span className="text-xs">Numero de áreas</span>
                            <span className="text-base">{tablePagination}</span>
                        </div>

                        <Search
                            placeholder="Búsqueda por área..."
                            onChange={handleChange}
                            value={searchValue}
                            className="w-full md:max-w-64 order-last sm:mt-2 md:mt-0 lg:ml-auto"
                        />
                    </>
                }
            >
                <div className="w-full flex justify-center">
                    <TableGeneral column={columns} state={tableFilterDataAreas} loading={isLoading} tableProps={tableProps} pagination={pagination} />
                </div>
            </CardDetailProject>
            <Modal title={`${typeModal === 0 ? "Crear area" : "Editar area"}`} width={420} onCancel={closeModal} open={activeModal} footer={[]}>
                <Form form={form} name="areas_user" layout="vertical" style={{ width: "100%" }} onFinish={onFinish}>
                    {typeModal === 0 && (
                        <div className="flex items-center justify-start gap-4 ">
                            <Form.Item name="isActive" label="¿El área está activa?" valuePropName="checked" className="flex h-6 relative top-3">
                                <Switch className="ml-4 relative bottom-[6px]" />
                            </Form.Item>
                        </div>
                    )}
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="name"
                                label="Nombre"
                                rules={[
                                    {
                                        required: true,
                                        message: "Nombre",
                                        whitespace: true,
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <div className="flex flex-col gap-3">
                                <label htmlFor="color">Selecciona un color</label>
                                <div className="flex items-center gap-2">
                                    <input
                                        className="w-6 h-[26px] bg-transparent px-[1px] border border-[#E6E6E6] rounded-md"
                                        type="color"
                                        name="color"
                                        value={color}
                                        onChange={changeColor}
                                    />
                                    <span>{color}</span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {typeModal === 0 && (
                        <div className="flex items-center justify-start gap-7">
                            <Form.Item name="canBeTeam" label="Equipo de trabajo" valuePropName="checked" className="flex h-6 relative top-3">
                                <Switch className="ml-7 relative bottom-[6px]" />
                            </Form.Item>
                        </div>
                    )}

                    <Form.Item className="w-full flex justify-end m-0 mt-4">
                        <Button type="primary" htmlType="submit" loading={loadingButton}>
                            {typeModal === 0 ? "Crear" : "Editar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
